import { type Utente } from '@framework/api-client/api/users/schemas/utente.ts';
import dayjs from 'dayjs';
import { type ISessionData } from './ISessionData.ts';

/**
 * Nel validatore sono tutte prefissate da `session`,
 * es. `session.richiedente.nome`
 */
export function getSessionValidationContext(
  user: Utente | null | undefined,
): ISessionData {
  const dataNascita = user?.datiAnagraficiAggiuntivi?.dataNascita;
  const dataRilascioCi =
    user?.datiAnagraficiAggiuntivi?.cartaIdentita?.dataRilascio;
  const dataScadenzaCi =
    user?.datiAnagraficiAggiuntivi?.cartaIdentita?.dataScadenza;

  //FWP-2463 #37705: Priorità alla mail SPID rispetto alla mail dell'utente
  const userEmail = user?.datiAnagraficiAggiuntivi?.email ?? user?.email;

  return {
    data_compilazione: dayjs().format('YYYY-MM-DD[T]HH:mm:ss'),
    richiedente: {
      nome: user?.nome,
      cognome: user?.cognome,
      email: userEmail,
      codiceFiscale: user?.codiceFiscale,
      codice_fiscale: user?.codiceFiscale,
    },
    datiAnagraficiAggiuntivi: {
      capDomicilioFisico: user?.datiAnagraficiAggiuntivi?.capDomicilioFisico,
      partitaIva: user?.datiAnagraficiAggiuntivi?.codiceIva,
      comuneDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.comuneDomicilioFisico,
      dataNascita:
        dataNascita && dayjs(dataNascita, 'YYYY-MM-DD').isValid()
          ? dayjs(dataNascita).format('YYYY-MM-DD')
          : undefined,
      genere: user?.datiAnagraficiAggiuntivi?.genere,
      indirizzo: user?.datiAnagraficiAggiuntivi?.indirizzo,
      indirizzoDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.indirizzoDomicilioFisico,
      indirizzoDigitale: user?.datiAnagraficiAggiuntivi?.indirizzoDigitale,
      nazioneDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.nazioneDomicilioFisico,
      numeroCellulare: user?.datiAnagraficiAggiuntivi?.numeroCellulare,
      paeseDiNascita: user?.datiAnagraficiAggiuntivi?.paeseDiNascita,
      provinciaDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.provinciaDomicilioFisico,
      sedeLegale: user?.datiAnagraficiAggiuntivi?.sedeLegale,
      tipologiaCi: user?.datiAnagraficiAggiuntivi?.cartaIdentita?.tipologia,
      idCi: user?.datiAnagraficiAggiuntivi?.cartaIdentita?.id,
      comuneRilascioCi:
        user?.datiAnagraficiAggiuntivi?.cartaIdentita?.comuneRilascio,
      dataRilascioCi:
        dataRilascioCi && dayjs(dataRilascioCi, 'YYYY-MM-DD').isValid()
          ? dayjs(dataRilascioCi).format('YYYY-MM-DD')
          : undefined,
      dataScadenzaCi:
        dataScadenzaCi && dayjs(dataScadenzaCi, 'YYYY-MM-DD').isValid()
          ? dayjs(dataScadenzaCi).format('YYYY-MM-DD')
          : undefined,
      denominazioneLuogoNascita:
        user?.datiAnagraficiAggiuntivi?.luogoDiNascita?.denominazione,
      codiceLuogoNascita:
        user?.datiAnagraficiAggiuntivi?.luogoDiNascita?.codice,
      denominazioneProvinciaNascita:
        user?.datiAnagraficiAggiuntivi?.provinciaDiNascita?.denominazione,
      codiceProvinciaNascita:
        user?.datiAnagraficiAggiuntivi?.provinciaDiNascita?.codice,
    },
  };
}
